export default "__VITE_ASSET__68f36abc__"